import { Classifier } from "./classifierManager";

export const isType = <T>(type: keyof T, ...matchTypes: Array<keyof T>) => {
  return matchTypes.some((matchType) => type === matchType);
};

/**
 * Seek the from array for a classifiewr with value = key and add to second array
 * @param from - source array
 * @param key - classifier.value key
 * @param to - sink array
 */
export const findAndAdd = (from: Classifier[], key: string, to: Classifier[]) => {
  const l = from.find((v) => v.value === key);
  if (l) {
    to.push(l);
  }
};

export const getOrdered = (inVals: Classifier[] | undefined, order: string[]) => {
  const results: Classifier[] = [];
  if (inVals) {
    for (let i = 0; i < order.length; i++) {
      findAndAdd(inVals, order[i], results);
    }
  }
  return results;
};

export const getOrderedByAsc = (options: Classifier[] | undefined) => {
  if (options) {
    options = [...options];
    options = options.sort((r1, r2) => (r1.label > r2.label ? 1 : -1));
  }
  return options;
};
